"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.join.js");
var _react = _interopRequireWildcard(require("react"));
var _BodyTag = _interopRequireDefault(require("../../lib/dom/BodyTag"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(props) {
  var isNavOpen = props.isNavOpen,
    onNavClose = props.onNavClose,
    children = props.children,
    renderLinks = props.renderLinks;
  var wrapperClasses = ['main-nav-wrapper'];
  var maskClasses = ['main-nav-mask'];
  var navClasses = ['main-nav', 'main-nav-push-right'];
  if (isNavOpen) {
    wrapperClasses.push('has-push-right');
    maskClasses.push('is-active');
    navClasses.push('is-active');
    _BodyTag["default"].addClass('has-active-menu');
  } else {
    _BodyTag["default"].removeClass('has-active-menu');
  }
  (0, _react.useEffect)(function () {
    return function () {
      // Remove body class when component unmounts
      _BodyTag["default"].removeClass('has-active-menu');
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClasses.join(' ')
  }, children), /*#__PURE__*/_react["default"].createElement("nav", {
    className: navClasses.join(' '),
    onClick: onNavClose
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "main-nav-close-btn"
  }), renderLinks(props)), /*#__PURE__*/_react["default"].createElement("div", {
    className: maskClasses.join(' '),
    onClick: onNavClose
  }));
};